export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <h2 className="section-title">关于我们</h2>
        <p className="section-subtitle">聚合热门平台，打造宅男专属的观影天地</p>
        <div className="mt-10 max-w-4xl mx-auto">
          <div className="bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-10">
            <div className="flex flex-col lg:flex-row gap-8 items-start">
              <div className="flex-shrink-0">
                <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-500 flex items-center justify-center">
                  <i className="ri-play-circle-fill text-white text-3xl md:text-4xl"></i>
                </div>
              </div>
              <div className="flex-1 space-y-4">
                <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                  宅男视频 — 你的专属视频聚合站
                </h3>
                <div className="text-sm md:text-base text-foreground-700 leading-relaxed space-y-3">
                  <p>
                    宅男视频是一个专注于男性用户群体的视频内容聚合平台，品牌整合了香蕉视频、红桃视频、蜜桃视频和樱花视频等多家热门视频平台的优质资源，致力于为广大宅男提供一站式的免费高清在线观看体验。
                  </p>
                  <p>
                    我们深度聚合各大平台最新、最热的影视内容，覆盖动作大片、悬疑烧脑剧、搞笑综艺、动漫番剧以及午夜影院等丰富品类。每日更新海量视频资源，确保用户总能看到新鲜内容。凭借强大的内容聚合能力和流畅的播放体验，宅男视频已成为千万男性用户每日必刷的视频入口。
                  </p>
                  <p>
                    平台坚持免费观看、无广告弹窗干扰的理念，采用先进的视频加速技术，保障高清流畅的观影体验。无论你是追剧达人还是电影爱好者，宅男视频都能满足你对优质视频内容的所有期待。
                  </p>
                </div>
                <div className="flex flex-wrap gap-4 pt-2">
                  <div className="flex items-center gap-2 px-4 py-2 bg-primary-50 rounded-lg">
                    <i className="ri-checkbox-circle-fill text-primary-500"></i>
                    <span className="text-sm font-medium text-foreground-800">全平台聚合</span>
                  </div>
                  <div className="flex items-center gap-2 px-4 py-2 bg-accent-50 rounded-lg">
                    <i className="ri-checkbox-circle-fill text-accent-500"></i>
                    <span className="text-sm font-medium text-foreground-800">免费高清</span>
                  </div>
                  <div className="flex items-center gap-2 px-4 py-2 bg-secondary-50 rounded-lg">
                    <i className="ri-checkbox-circle-fill text-secondary-500"></i>
                    <span className="text-sm font-medium text-foreground-800">每日更新</span>
                  </div>
                  <div className="flex items-center gap-2 px-4 py-2 bg-primary-50 rounded-lg">
                    <i className="ri-checkbox-circle-fill text-primary-500"></i>
                    <span className="text-sm font-medium text-foreground-800">安全流畅</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}